export default __webpack_public_path__ + "static/media/PropertyContent.f41fd2e8.svg";